import { render } from "./AccountsDashboard.vue?vue&type=template&id=455762a2"
import script from "./AccountsDashboard.vue?vue&type=script&lang=js"
export * from "./AccountsDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/home/desarollo2/Documents/GitHub/dicora-customers-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__